import React from 'react'
import { CollectionBlockType } from '../../types'

interface Props {
  block: CollectionBlockType
}

export const CollectionBlockImage: React.FC<Props> = ({ block }) => (
  <div
    className="colblock-imgwrap"
    style={{
      backgroundColor: '#ddd',
      paddingBottom: `${(2 / 3) * 100}%`,
      position: 'relative',
    }}
  >
    <img
      src={block.image.sizes.large}
      alt={block.title}
      className="colblock-img"
      style={{ position: 'absolute', top: 0, left: 0 }}
    />
  </div>
)
